import { render, staticRenderFns } from "./OpportunityLeftPanel.vue?vue&type=template&id=389cb8d1&scoped=true"
import script from "./OpportunityLeftPanel.vue?vue&type=script&lang=js"
export * from "./OpportunityLeftPanel.vue?vue&type=script&lang=js"
import style0 from "./OpportunityLeftPanel.vue?vue&type=style&index=0&id=389cb8d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389cb8d1",
  null
  
)

export default component.exports